import moment from 'moment'
import { modifyTime } from './index'

const IDS = {
  // 通用
  CLEAR: 'clear',
  MONTH_SELECT: 'monthSelect',
  // 天
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  BEFORE_YESTERDAY: 'beforeYesterday',
  DAY_3_AGO: 'day3Ago',
  DAY_7_AGO: 'day7Ago',
  DAY_15_AGO: 'day15Ago',
  DAY_30_AGO: 'day30Ago',
  // 近x天
  RECENT_3_DAYS: 'recent3Days',
  RECENT_5_DAYS: 'recent5Days',
  RECENT_7_DAYS: 'recent7Days',
  // 月
  CURRENT_MONTH: 'currentMonth',
  PREV_MONTH: 'prevMonth',
  NEXT_MONTH: 'nextMonth',
  // 近x月
  RECENT_1_MONTH: 'recent1Month',
  RECENT_2_MONTHS: 'recent2Months',
  RECENT_3_MONTHS: 'recent3Months',
  RECENT_6_MONTHS: 'recent6Months',
  // 周
  RECENT_1_WEEK: 'recent1Week',
  PREV_WEEK: 'prevWeek',
  NEXT_WEEK: 'nextWeek',
  // 年
  YEAR_TO_DATE: 'yearToDate',
  RECENT_1_YEAR: 'recent1Year',
}

const MONTH_SELECT = {
  text: '选择月',
  id: IDS.MONTH_SELECT
}

const CLEAR_SELECT = {
  text: '清除',
  id: IDS.CLEAR
}

const modifyStartTime = (date = new Date()) => {
  return modifyTime(date, 0, 0, 0)
}

const modifyEndTime = (date = new Date()) => {
  return modifyTime(date, 23, 59, 59)
}

const getPrevDay = (day) => {
  return moment().subtract(day, 'days').toDate()
}

// const modifyEndTime = () => {
//   return moment().toDate()
// }

const getPrevMonth = (month) => {
  return moment().subtract(month, 'month').toDate()
}

const modifyStartWeek = (week) => {
  return moment().subtract(week, 'week').toDate()
}


const DEFAULT_SHORTCUTS_MAP = {
  date: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      id: IDS.TODAY,
      text: '今天',
      value: () => modifyStartTime(getPrevDay(0)),
    },
    {
      id: IDS.YESTERDAY,
      text: '昨天',
      value: () => modifyStartTime(getPrevDay(1)),
    },
    {
      id: IDS.BEFORE_YESTERDAY,
      text: '前天',
      value: () => modifyStartTime(getPrevDay(2)),
    },
    {
      id: IDS.DAY_3_AGO,
      text: '3天前',
      value: () => modifyStartTime(getPrevDay(3)),
    },
    {
      id: IDS.DAY_15_AGO,
      text: '15天前',
      value: () => modifyStartTime(getPrevDay(15)),
    },
    {
      id: IDS.DAY_30_AGO,
      text: '30天前',
      value: () => modifyStartTime(getPrevDay(30)),
    },
    {
      id: IDS.DAY_7_AGO,
      text: '1周前',
      value: () => modifyStartTime(getPrevDay(7)),
    },
    { ...MONTH_SELECT }
  ],
  daterange: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClearOperation()
      }
    },
    {
      id: IDS.CURRENT_MONTH,
      text: '当月', // 这个月的第一天 - 个月的今天
      value: () => [modifyStartTime(moment().startOf('month').toDate()), modifyEndTime(moment().toDate())],
    },
    {
      id: IDS.PREV_MONTH,
      text: '上月',
      value: () => [modifyStartTime(moment().subtract(1, 'months').startOf('month').toDate()), modifyEndTime(moment().subtract(1, 'months').endOf('month').toDate())],
    },
    {
      id: IDS.NEXT_MONTH,
      text: '下月',
      value: () => [modifyStartTime(moment().add(1, 'months').startOf('month').toDate()), modifyEndTime(moment().add(1, 'months').endOf('month').toDate())],
    },
    {
      id: IDS.TODAY,
      text: '今天',
      value: () => [modifyStartTime(), modifyEndTime()],
    },
    {
      id: IDS.YESTERDAY,
      text: '昨天',
      value: () => [modifyStartTime(getPrevDay(1)), modifyEndTime(getPrevDay(1))],
    },
    {
      id: IDS.RECENT_1_WEEK,
      text: '最近1周',
      value: () => [modifyStartTime(getPrevDay(6)), modifyEndTime()],
    },
    {
      id: IDS.RECENT_1_MONTH,
      text: '最近1个月',
      value: () => [modifyStartTime(getPrevDay(29)), modifyEndTime()],
    },
    {
      id: IDS.RECENT_3_MONTHS,
      text: '最近3个月',
      value: () => [modifyStartTime(getPrevDay(89)), modifyEndTime()],
    },
    {
      id: IDS.RECENT_6_MONTHS,
      text: '最近6个月',
      value: () => [modifyStartTime(getPrevDay(179)), modifyEndTime()],
    },
    {
      id: IDS.YEAR_TO_DATE,
      text: '今年至今',
      value: () => [modifyStartTime(new Date(new Date().getFullYear(), 0)), modifyEndTime()],
    },
    { ...MONTH_SELECT }
  ],
  datetime: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      id: IDS.TODAY,
      text: '今天',
      value: () => modifyStartTime(getPrevDay(0)),
    },
    {
      id: IDS.YESTERDAY,
      text: '昨天',
      value: () => modifyStartTime(getPrevDay(1)),
    },
    {
      id: IDS.BEFORE_YESTERDAY,
      text: '前天',
      value: () => modifyStartTime(getPrevDay(2)),
    },
    {
      id: IDS.DAY_3_AGO,
      text: '3天前',
      value: () => modifyStartTime(getPrevDay(3)),
    },
    {
      id: IDS.DAY_15_AGO,
      text: '15天前',
      value: () => modifyStartTime(getPrevDay(15)),
    },
    {
      id: IDS.DAY_30_AGO,
      text: '30天前',
      value: () => modifyStartTime(getPrevDay(30)),
    },
    {
      id: IDS.DAY_7_AGO,
      text: '1周前',
      value: () => modifyStartTime(getPrevDay(7)),
    },
    { ...MONTH_SELECT }
  ],
  datetimerange: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClearOperation()
      },
    },
    {
      id: IDS.CURRENT_MONTH,
      text: '当月', // 这个月的第一天 - 个月的今天
      value: () => [modifyStartTime(moment().startOf('month').toDate()), modifyEndTime(moment().toDate())],
    },
    {
      id: IDS.PREV_MONTH,
      text: '上月',
      value: () => [modifyStartTime(moment().subtract(1, 'months').startOf('month').toDate()), modifyEndTime(moment().subtract(1, 'months').endOf('month').toDate())],
    },
    {
      id: IDS.NEXT_MONTH,
      text: '下月',
      value: () => [modifyStartTime(moment().add(1, 'months').startOf('month').toDate()), modifyEndTime(moment().add(1, 'months').endOf('month').toDate())],
    },
    {
      id: IDS.TODAY,
      text: '今天',
      value: () => [modifyStartTime(), modifyEndTime()],
    },
    {
      id: IDS.YESTERDAY,
      text: '昨天',
      value: () => [modifyStartTime(getPrevDay(1)), modifyEndTime(getPrevDay(1))],
    },
    {
      id: IDS.RECENT_1_WEEK,
      text: '最近1周',
      value: () => [modifyStartTime(getPrevDay(6)), modifyEndTime()],
    },
    {
      id: IDS.RECENT_1_MONTH,
      text: '最近1个月',
      value: () => [modifyStartTime(getPrevDay(29)), modifyEndTime()],
    },
    {
      id: IDS.RECENT_3_MONTHS,
      text: '最近3个月',
      value: () => [modifyStartTime(getPrevDay(89)), modifyEndTime()],
    },
    {
      id: IDS.RECENT_6_MONTHS,
      text: '最近6个月',
      value: () => [modifyStartTime(getPrevDay(179)), modifyEndTime()],
    },
    {
      id: IDS.YEAR_TO_DATE,
      text: '今年至今',
      value: () => [modifyStartTime(new Date(new Date().getFullYear(), 0)), modifyEndTime()],
    },
    { ...MONTH_SELECT }
  ],
  month: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      id: IDS.CURRENT_MONTH,
      text: '当月',
      value: () => getPrevMonth(0),
    },
    {
      id: IDS.PREV_MONTH,
      text: '上月',
      value: () => getPrevMonth(1),
    },
    {
      id: IDS.NEXT_MONTH,
      text: '下月',
      value: () => getPrevMonth(-1),
    },
  ],
  monthrange: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        // picker.$emit('pick', null, false)
        picker.handleClearOperation()
      },
    },
    {
      id: IDS.PREV_MONTH,
      text: '上月',
      value: () => [modifyStartTime(getPrevMonth(1)), modifyEndTime(getPrevMonth(1))],
    },
    {
      id: IDS.CURRENT_MONTH,
      text: '本月',
      value: () => [modifyStartTime(), modifyEndTime()],
    },
    {
      id: IDS.RECENT_3_MONTHS,
      text: '最近3个月',
      value: () => [getPrevMonth(2), modifyEndTime()],
    },
    {
      id: IDS.RECENT_6_MONTHS,
      text: '最近6个月',
      value: () => [getPrevMonth(5), modifyEndTime()],
    },
    {
      id: IDS.YEAR_TO_DATE,
      text: '今年至今',
      value: () => [modifyStartTime(new Date(new Date().getFullYear(), 0)), modifyEndTime()],
    },
  ],
  week: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      id: IDS.PREV_WEEK,
      text: '上周',
      value: () => modifyStartWeek(1),
    },
    {
      id: IDS.NEXT_WEEK,
      text: '下周',
      value: () => modifyStartWeek(-1),
    }
  ],
  dates: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      id: IDS.RECENT_3_DAYS,
      text: '最近3天',
      value: () => Array.from({length: 3}).map((_, i) => getPrevDay(i)).reverse(),
    },
    {
      id: IDS.RECENT_5_DAYS,
      text: '最近5天',
      value: () => Array.from({length: 5}).map((_, i) => getPrevDay(i)).reverse(),
    },
    {
      id: IDS.RECENT_1_WEEK,
      text: '最近1周',
      value: () => Array.from({length: 7}).map((_, i) => getPrevDay(i)).reverse(),
    },
  ],
  months: [
    {
      ...CLEAR_SELECT,
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      id: IDS.PREV_MONTH,
      text: '上月',
      value: () => [getPrevMonth(1)],
    },
    {
      id: IDS.RECENT_2_MONTHS,
      text: '近2个月',
      value: () => Array.from({length: 2}).map((_, i) => getPrevMonth(i)),
    },
    {
      id: IDS.RECENT_3_MONTHS,
      text: '近3个月',
      value: () => Array.from({length: 3}).map((_, i) => getPrevMonth(i))
    },
    {
      id: IDS.RECENT_6_MONTHS,
      text: '近6个月',
      value: () => Array.from({length: 6}).map((_, i) => getPrevMonth(i))
    },
    {
      id: IDS.RECENT_1_YEAR,
      text: '近1年',
      value: () => Array.from({length: 12}).map((_, i) => getPrevMonth(i))
    },
  ]
}

export function createDefaultShortcuts(type) {
  try {
    return DEFAULT_SHORTCUTS_MAP[type] || []
  } catch (error) {
    return []
  }
}

export const MONTH_LIST = [
  '一月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月',
].map((v, i) => ({ text: v, value: i + 1 }))




// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker3/src/util/shortcuts.js